import { Button, ButtonProps } from 'antd'
import React from 'react'
import { styled } from 'styled-components'
import { DesignSystem } from '~/core/designSystem'

const Wrapper = styled(Button)`
  background: ${DesignSystem.ThemeConst.PRIMARY_YELLOW};
  color: black;
  border-color: ${DesignSystem.ThemeConst.PRIMARY_YELLOW};

  &:active,
  &:hover {
    background: ${DesignSystem.ThemeConst.PRIMARY_YELLOW} !important;
    color: black !important;
    border-color: ${DesignSystem.ThemeConst.PRIMARY_YELLOW} !important;
  }
`

type Props = ButtonProps

export const ButtonPrimary: React.FC<Props> = ({ children, ...props }) => {
  return <Wrapper {...props}>{children}</Wrapper>
}
